import React, { useEffect } from 'react'
import Hero from '../components/Home/Hero'
import HayStory from '../components/Home/HayStory'
import Post from '../components/Home/Post'
import Haystack from '../components/Home/Haystack'
import Footer from '../components/Footer'

const Home = () => {
    useEffect(() => {
        document.title = 'Haystack Conference | Whitefield Missions'
        let description = document.head.querySelector('meta[name="description"]')
        if (!description) {
            description = document.createElement('meta')
            description.setAttribute('name', 'description')
            document.head.appendChild(description)
        }
        description.setAttribute('content', 'Join the Haystack Conference, where prayer, missions, and a passion for the Gospel come together to reach the nations.')
    }, [])

    return (
        <div >
            <Hero />
            <HayStory />
            <Post />
            <Haystack />
            <Footer />
        </div>
    )
    }

export default Home
